var mapNumber=function(a,b,c,d,e){return(a-b)*(e-d)/(c-b)+d};export default mapNumber;